// cauSucKhoe.ts — tình trạng cầu đồng bộ cho Admin (0358, rpc_dong_bo_suc_khoe ~1 KB). Chỉ Admin gọi; hỏi lại mỗi 5 phút khi tab đang hiện
// + khi quay lại cửa sổ ⇒ ~12 người nhưng chỉ 1–2 Admin ⇒ egress không đáng kể. Luật cảnh báo ở core/canhBaoCau.
import { useQuery } from "@tanstack/react-query";
import { docSucKhoe, type SucKhoeCau } from "../core/canhBaoCau";
import { goiRpc } from "./rpc";

export const khoaSucKhoeCau = (userId: string) => ["cau_suc_khoe", userId] as const;

export function useSucKhoeCau(userId: string, bat: boolean) {
  return useQuery<SucKhoeCau>({
    queryKey: khoaSucKhoeCau(userId),
    queryFn: async () => {
      const k = await goiRpc<unknown>("rpc_dong_bo_suc_khoe", {});
      if (!k.ok) throw new Error(k.error);
      return docSucKhoe(k.data);
    },
    enabled: bat,
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    // migration chưa chạy (hàm chưa có) / lỗi mạng ⇒ im lặng, không báo cảnh báo giả
    retry: 1,
  });
}
